/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */
import type {
  ServiceProviderGroup,
  ServiceProvidersListParams
} from '../../model';

import { customFetch } from '../../../liftApiMutator';

export type serviceProvidersListResponse200 = {
  data: ServiceProviderGroup[]
  status: 200
}

export type serviceProvidersListResponseSuccess = (serviceProvidersListResponse200) & {
  headers: Headers;
};
;

export type serviceProvidersListResponse = (serviceProvidersListResponseSuccess)

export const getServiceProvidersListUrl = (params?: ServiceProvidersListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/service-providers/?${stringifiedParams}` : `/api/v1/service-providers/`
}

/**
 * Returns a list of ServiceProviderGroups that service Cars on properties
 * managed by the ConsultantGroup of the authenticated user.
 */
export const serviceProvidersList = async (params?: ServiceProvidersListParams, options?: RequestInit): Promise<serviceProvidersListResponse> => {

  return customFetch<serviceProvidersListResponse>(getServiceProvidersListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}


export type serviceProvidersRetrieveResponse200 = {
  data: ServiceProviderGroup
  status: 200
}

export type serviceProvidersRetrieveResponseSuccess = (serviceProvidersRetrieveResponse200) & {
  headers: Headers;
};
;

export type serviceProvidersRetrieveResponse = (serviceProvidersRetrieveResponseSuccess)

export const getServiceProvidersRetrieveUrl = (id: string,) => {




  return `/api/v1/service-providers/${id}/`
}

/**
 * Returns a list of ServiceProviderGroups that service Cars on properties
 * managed by the ConsultantGroup of the authenticated user.
 */
export const serviceProvidersRetrieve = async (id: string, options?: RequestInit): Promise<serviceProvidersRetrieveResponse> => {

  return customFetch<serviceProvidersRetrieveResponse>(getServiceProvidersRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}


